import React from 'react'
import { Icon, Message, Popup, Segment } from 'semantic-ui-react'
import PropTypes from "prop-types";
import { useTextResources } from '../../../language';

const Panel = ({ header, subheader, children, overflow, menu, icon, segments, info, collapsable, collapsed, onCollapse, ...rest }) => {
    const text = useTextResources()
    const showInfo = info && (header || subheader)
    const showCollapse = collapsable && (header || subheader)
    return (
        <Segment.Group style={{ display: "flex", flexDirection: "column", flex: 1, ...(rest?.style || {}) }}>
            {(header || subheader) && <Message icon={icon} header={header} content={subheader} attached={collapsed?"":"top"}/> }
            {showInfo && <Popup trigger={<Icon style={{position: "absolute", right: "0.5em", top: "1.0em"}} link name='info' circular size='small'/>} content={text(info)}/>}
            {showCollapse && <Icon style={{position: "absolute", right: showInfo?"1.5em":"0.5em", top: "0.5em"}} link name={collapsed?"angle down":"angle up"} size="large" onClick={()=>onCollapse?.(!collapsed)}/>}
            {menu}
            {!collapsed && <>
                <Segment attached={(header || subheader) ? "bottom" : undefined} style={{ flex: 1, overflow: overflow || "inherit" }} {...rest}>
                    {children}
                </Segment>
                {segments}
            </>}
        </Segment.Group>
    )}
Panel.propTypes = {
    header: PropTypes.any,
    subheader: PropTypes.any,
    children: PropTypes.any,
    overflow: PropTypes.string,
    menu: PropTypes.element,
    icon: PropTypes.any,
    segments: PropTypes.array,
    info: PropTypes.string,
    collapsable: PropTypes.bool,
    collapsed: PropTypes.bool,
    onCollapse: PropTypes.func
}
export default Panel